<script lang="ts" setup>
import { useValidator } from '@/composeables';
import type { ValidatorDef } from '@/objects/gui/ValidatorDef';
import { LocaleFormatNumeric } from '@/utilities/utils';

const props = withDefaults(
    defineProps<{
        value: number | null;
        validator?: ValidatorDef | null;
        decimal?: number;
    }>(),
    { value: null, decimal: 2 },
);

const { ValidateMessage } = useValidator(props.validator ?? null, props.value);

const formatValue = (value: number | null) => {
    if (value == null) {
        return '';
    }

    return LocaleFormatNumeric(value, undefined, {
        minimumFractionDigits: props.decimal ?? 2,
        maximumFractionDigits: props.decimal ?? 2,
    });
};
</script>

<template>
    <div
        class="field-renderer-number"
        :class="[ValidateMessage != null ? 'alert alert-' + ValidateMessage.type : '']"
    >
        {{ formatValue(value) }}
    </div>
</template>
